import type {
  MessageBarBodySlots as MessageBarBodyBaseSlots,
  MessageBarBodyProps as MessageBarBodyBaseProps,
  MessageBarBodyState as MessageBarBodyBaseState,
  MessageBarBodyContextValues as MessageBarBodyBaseContextValues,
} from '@fluentui/react-message-bar';

export type MessageBarBodySlots = MessageBarBodyBaseSlots;

export type MessageBarBodyProps = MessageBarBodyBaseProps;

export type MessageBarBodyState = MessageBarBodyBaseState;

export type MessageBarBodyContextValues = MessageBarBodyBaseContextValues;
